<template>
  <div
    class="row justify-between"
    style="height: 100%;  width: 100%; min-width: 900px"
    v-if="contact"
  >
    <PanelPreviewData
      :attendance-id="attendanceId"
      :queue-id="queueId"
      :show-return-button="true"
      :contact="contact"
      style="margin-right: 0.5%;"
      class="col"
    />
    <AppAttendanceItem
      style="border: 1px solid #c5c5c5; border-radius: 3px; "
      :attendance-id="attendanceId"
      class="col"
      :is-preview="true"
    />
  </div>
  <PanelPreviewAlert
    v-else
    class="full-height"
    title="Carregando próximo contato !"
    subtitle-title="Buscando próximo contato disponível"
    subtitle-text="Aguarde um momento"
    :loading="true"
  />
</template>

<script>
import PanelPreviewData from '@/components/PanelPreviewData.vue'
import { mapGetters } from 'vuex'
import AppAttendanceItem from './AppAttendanceItem.vue'
import PanelPreviewAlert from '@/components/PanelPreviewAlert.vue'

export default {
  components: {
    PanelPreviewData, AppAttendanceItem, PanelPreviewAlert
  },

  props: {

  },

  data () {
    return {
      queueId: this.$route.params.queueId,
      attendanceId: this.$route.params.attendanceId,
      contact: null
    }
  },

  mounted () {
    this.contact = this.previewContacts[this.queueId]
  },

  methods: {

  },

  computed: {
    ...mapGetters({
      isAdmin: 'settingsModule/isAdmin'
    }),

    ...mapGetters({
      previewContacts: 'attendanceModule/previewContacts'
    })

  },

  watch: {

  }
}

</script>
